import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Button, Checkbox, Collapse, Form, Input, Modal, Select, Space, Spin, Tooltip } from 'antd';

import { isEmpty, isNumber, isString } from 'lodash';

import { PdfViewerComponent } from '../../../shared/components/pdf-viewer';
import * as enums from '../../../shared/constants/enums';
import MappingTree from '../mapping-tree';
import * as mappingConstants from '../store/constants/mapping-constants';
import FieldItem from './field-item';

const { Panel } = Collapse;

const { TextArea } = Input;

const mappingModal = ({
  rootContainer,
  userMappingObjects,
  setNewUserMappings,
  loading,
  fileBytes,
  registerFormSaveCallback,
  onPdfLoadedEvent,
  fileEditorLoading,
  registerFormClearCallback,
  setIsDocumentChanged,
}) => {
  const [mappingNameForm] = Form.useForm();

  const inputRef = useRef(null);

  const [showMappingModal, setShowMappingModal] = useState(false);
  const [cleanModalData, setCleanModalData] = useState(false);
  const [targetName, setTargetName] = useState();
  const [currentMappedField, setCurrentMappedField] = useState({});
  const [targetFocus, setTargetFocus] = useState();
  const [userObjectType, setUserObjectType] = useState();
  const [texAreaCheckboxValue, setTexAreaCheckboxValue] = useState(false);
  const [calculateSumCheckboxValue, setCalculateSumCheckboxValue] = useState(false);

  const [formatCategoryType, setFormatCategoryType] = useState(enums.customFormFieldFormatCategory.None);

  const mappingObjectNames = useSelector((state) => state.customForm.mappingObjectNames);
  const mappingObjectNamesLoading = useSelector((state) => state.customForm.mappingObjectNamesLoading);

  useEffect(() => {}, []);

  useEffect(() => {
    showMappingModal ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'unset');
  }, [showMappingModal]);

  const onFormEditorClick = (event) => {
    const tagName = event?.target?.type;

    if (
      tagName !== 'text' &&
      tagName !== 'checkbox' &&
      tagName !== 'textarea' &&
      tagName !== 'radio' &&
      tagName !== 'select-multiple' &&
      tagName !== 'select-one'
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    inputRef.current = event.target;

    setTargetName(event.target.name);

    const obj = userMappingObjects.find((element) => element.formFieldName === event.target.name);

    if (obj && obj.type == enums.customFormMappingObjectTypes.CustomText) {
      setCurrentMappedField(undefined);
      mappingNameForm.setFieldsValue({
        [mappingConstants.CUSTOM_TEXT_FIELD_NAME]: obj.objectName,
      });
      setTexAreaCheckboxValue(true);
      setUserObjectType(enums.customFormMappingObjectTypes.CustomText);
    } else if (obj && obj.type == enums.customFormMappingObjectTypes.CustomTextCalculated) {
      setCurrentMappedField(undefined);
      mappingNameForm.setFieldsValue({
        [mappingConstants.CUSTOM_TEXT_FIELD_NAME]: obj.objectName,
      });
      setTexAreaCheckboxValue(true);
      setCalculateSumCheckboxValue(true);
      setUserObjectType(enums.customFormMappingObjectTypes.CustomTextCalculated);
    } else {
      setCurrentMappedField(obj);
    }

    const customFormFieldFormatCategoryValue =
      obj?.isCurrencyField === true
        ? enums.customFormFieldFormatCategory.Currency
        : obj?.isNoCentsField === true
        ? enums.customFormFieldFormatCategory.CurrencyNoCents
        : obj?.isNumberField === true
        ? enums.customFormFieldFormatCategory.DecimalNumber
        : obj?.isIntegerField === true
        ? enums.customFormFieldFormatCategory.IntegerNumber
        : enums.customFormFieldFormatCategory.None;

    setFormatCategoryType(customFormFieldFormatCategoryValue);
    mappingNameForm.setFieldsValue({
      special_format: customFormFieldFormatCategoryValue,
    });

    setCleanModalData(false);
    setShowMappingModal(true);
  };

  const onCancel = () => {
    setShowMappingModal(false);
  };

  const onOk = () => {
    mappingNameForm.validateFields().then((result) => {
      updateUserMapping(result);
      setShowMappingModal(false);
    });
  };

  const updateUserMapping = (formsFields) => {
    let newMappings = userMappingObjects.slice();

    if (formsFields) {
      let mappedObj;
      if (texAreaCheckboxValue === true) {
        let customTextObject = formsFields[mappingConstants.CUSTOM_TEXT_FIELD_NAME];
        mappedObj =
          isString(customTextObject) && !isEmpty(customTextObject)
            ? {
                objectName: customTextObject,
                isCurrencyField: formatCategoryType === enums.customFormFieldFormatCategory.Currency,
                isNumberField: formatCategoryType === enums.customFormFieldFormatCategory.DecimalNumber,
                isNoCentsField: formatCategoryType === enums.customFormFieldFormatCategory.CurrencyNoCents,
                isIntegerField: formatCategoryType === enums.customFormFieldFormatCategory.IntegerNumber,
              }
            : undefined;

        mappedObj.type = enums.customFormMappingObjectTypes.CustomText;

        if (calculateSumCheckboxValue && formatCategoryType === enums.customFormFieldFormatCategory.None) {
          mappedObj.isNumberField = true;
        }
      } else {
        mappedObj = getUserMappingObjectFromFormFields(formsFields, 0);

        if (mappedObj) {
          mappedObj.isCurrencyField = formatCategoryType === enums.customFormFieldFormatCategory.Currency;
          mappedObj.isNumberField = formatCategoryType === enums.customFormFieldFormatCategory.DecimalNumber;
          mappedObj.isNoCentsField = formatCategoryType === enums.customFormFieldFormatCategory.CurrencyNoCents;
          mappedObj.isIntegerField = formatCategoryType === enums.customFormFieldFormatCategory.IntegerNumber;
        }

        mappedObj.type = userObjectType;
      }

      if (mappedObj) {
        mappedObj.formFieldName = targetName;

        const objIndex = newMappings.findIndex(
          (element) => element.formFieldName == mappedObj.formFieldName || (isEqualObjects(element, mappedObj) && !texAreaCheckboxValue),
        );

        if (newMappings.length > 0 && objIndex !== -1) {
          const element = document.getElementsByName(newMappings[objIndex].formFieldName)[0];
          if (element) {
            element.style.backgroundColor = 'transparent';
          }

          newMappings[objIndex] = mappedObj;
        } else {
          newMappings.push(mappedObj);
        }
      } else {
        const objIndex = newMappings.findIndex((element) => element.formFieldName == targetName);

        if (objIndex !== -1) {
          const element = document.getElementsByName(newMappings[objIndex].formFieldName)[0];
          if (element) {
            element.style.backgroundColor = 'transparent';
          }

          newMappings = newMappings.filter((value) => {
            return value.formFieldName != targetName;
          });
        }
      }

      setNewUserMappings(newMappings);
    }
  };

  const getUserMappingObjectFromFormFields = (formsFields, level) => {
    let childMapping;

    if (!isEmpty(formsFields[mappingConstants.OBJECT_FIELD_NAME + level])) {
      childMapping = {};
      childMapping.objectKey = formsFields[mappingConstants.OBJECT_FIELD_NAME + level];
      childMapping.objectPosition = formsFields[mappingConstants.POSITION_FIELD_NAME + level];
      childMapping.childMapping = getUserMappingObjectFromFormFields(formsFields, level + 1);
    }

    return childMapping;
  };

  const isEqualObjects = (element, newElement) => {
    return (
      element.objectKey == newElement.objectKey &&
      element.objectPosition == newElement.objectPosition &&
      (!(element.childMapping && newElement.childMapping) || isEqualObjects(element.childMapping, newElement.childMapping))
    );
  };

  const afterCloseModal = () => {
    mappingNameForm.resetFields();
    setTargetName();
    setCurrentMappedField();
    setUserObjectType();
    setCleanModalData(true);
    setTexAreaCheckboxValue(false);
    setCalculateSumCheckboxValue(false);

    if (inputRef.current) {
      inputRef.current.blur();
      inputRef.current = null;
    }

    setFormatCategoryType(enums.customFormFieldFormatCategory.None);
    mappingNameForm.setFieldsValue({
      special_format: enums.customFormFieldFormatCategory.None,
    });

    if (targetFocus) {
      targetFocus.focus();

      targetFocus.classList.add('blink-background');

      const timer = setInterval(() => {
        clearInterval(timer);
        targetFocus.classList.remove('blink-background');
      }, 1000);

      setTargetFocus();
    }
  };

  const onTexAreaCheckboxChange = (event) => {
    const value = event?.target?.checked ?? false;

    setTexAreaCheckboxValue(value);

    if (value === true) {
      setUserObjectType(enums.customFormMappingObjectTypes.CustomText);
    } else {
      mappingNameForm.setFieldsValue({
        [mappingConstants.CUSTOM_TEXT_FIELD_NAME]: '',
      });
      setUserObjectType();
      setCalculateSumCheckboxValue(false);
    }
  };

  const onCalculateSumCheckboxChange = (event) => {
    const value = event?.target?.checked ?? false;

    setCalculateSumCheckboxValue(value);

    if (value === true) {
      setUserObjectType(enums.customFormMappingObjectTypes.CustomTextCalculated);
      setTexAreaCheckboxValue(true);

      mappingNameForm.setFieldsValue({
        [mappingConstants.CUSTOM_TEXT_FIELD_NAME]: '',
      });
    } else {
      setUserObjectType(enums.customFormMappingObjectTypes.CustomText);
    }
  };

  const onClearClick = (event) => {
    mappingNameForm.setFieldsValue({
      [mappingConstants.CUSTOM_TEXT_FIELD_NAME]: '',
    });
  };

  const onAddObjectMapToTextareaClick = () => {
    const fieldsValue = mappingNameForm.getFieldsValue();
    setObjectMapToTextarea(fieldsValue);
  };

  const setObjectMapToTextarea = (formsFields) => {
    let level = 0;

    if (formsFields) {
      const mappedObjStr = getStringMappingObjectFromFormFields(formsFields, level);
      let value = mappingNameForm.getFieldValue('customText');

      if (isEmpty(value)) {
        value = '{' + mappedObjStr + '}';
      } else if (calculateSumCheckboxValue) {
        value += ' + ' + '{' + mappedObjStr + '}';
      } else {
        value += '{' + mappedObjStr + '}';
      }

      mappingNameForm.setFieldsValue({
        customText: value,
      });
    }
  };

  const getStringMappingObjectFromFormFields = (formsFields, level) => {
    let addStringMap;

    if (!isEmpty(formsFields[mappingConstants.OBJECT_FIELD_NAME + level])) {
      addStringMap = formsFields[mappingConstants.OBJECT_FIELD_NAME + level];

      if (isNumber(formsFields[mappingConstants.POSITION_FIELD_NAME + level])) {
        addStringMap += '[' + formsFields[mappingConstants.POSITION_FIELD_NAME + level] + ']';
      }

      let childAddStringMap = getStringMappingObjectFromFormFields(formsFields, level + 1);

      if (!isEmpty(childAddStringMap)) {
        addStringMap += '.' + childAddStringMap;
      }
    }

    return addStringMap;
  };

  const handleFormatCategoryChange = (value) => {
    setFormatCategoryType(value);
  };

  return (
    <>
      <PdfViewerComponent
        rootContainer={rootContainer}
        fileBytes={fileBytes}
        onFormEditorClick={onFormEditorClick}
        registerFormSaveCallback={registerFormSaveCallback}
        onPdfLoadedEvent={onPdfLoadedEvent}
        loading={fileEditorLoading}
        registerFormClearCallback={registerFormClearCallback}
        setIsDocumentChanged={setIsDocumentChanged}
      />

      {cleanModalData ? undefined : (
        <Modal
          className="mapping-modal"
          title="Map Field To Object"
          open={showMappingModal}
          getContainer={rootContainer}
          centered
          width={800}
          onCancel={onCancel}
          onOk={onOk}
          okText="Save"
          okButtonProps={{ loading }}
          afterClose={afterCloseModal}
          footer={[
            <Button key="back" onClick={onCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" loading={loading} onClick={onOk}>
              Ok
            </Button>,
          ]}
        >
          {!showMappingModal || mappingObjectNamesLoading ? (
            <Spin spinning />
          ) : (
            <>
              <Form name="mapping_name_form" form={mappingNameForm} size="small">
                <Collapse size="small" defaultActiveKey={1}>
                  <Panel header="Map the selected field to the following object property" key="1" size="small">
                    <FieldItem
                      originalMappingObjects={mappingObjectNames}
                      rootContainer={rootContainer}
                      level={0}
                      mappingNameForm={mappingNameForm}
                      skipRequired={true}
                      setUserObjectType={setUserObjectType}
                      currentMappedField={currentMappedField}
                      setCurrentMappedField={setCurrentMappedField}
                    />

                    <Tooltip getPopupContainer={rootContainer} placement="topLeft" title={'This is optional format category.'}>
                      <Form.Item name="special_format" label="Special format" initialValue={enums.customFormFieldFormatCategory.None}>
                        <Select
                          getPopupContainer={rootContainer}
                          value={formatCategoryType}
                          onChange={handleFormatCategoryChange}
                          options={[
                            {
                              value: enums.customFormFieldFormatCategory.None,
                              label: 'None',
                            },
                            {
                              value: enums.customFormFieldFormatCategory.Currency,
                              label: 'Currency',
                            },
                            {
                              value: enums.customFormFieldFormatCategory.CurrencyNoCents,
                              label: 'Currency no cents',
                            },
                            {
                              value: enums.customFormFieldFormatCategory.DecimalNumber,
                              label: 'Decimal number',
                            },
                            {
                              value: enums.customFormFieldFormatCategory.IntegerNumber,
                              label: 'Integer number',
                            },
                          ]}
                        />
                      </Form.Item>
                    </Tooltip>

                    <Form.Item>
                      <Checkbox className="text-area-controls" onChange={onTexAreaCheckboxChange} checked={texAreaCheckboxValue}>
                        Custom text
                      </Checkbox>

                      {texAreaCheckboxValue ? (
                        <>
                          <Tooltip
                            getPopupContainer={rootContainer}
                            placement="topLeft"
                            title={'Value is the sum(+) of the following fields in the custom text'}
                          >
                            <Checkbox className="text-area-controls" onChange={onCalculateSumCheckboxChange} checked={calculateSumCheckboxValue}>
                              Calculate sum(+)
                            </Checkbox>
                          </Tooltip>

                          <Space>
                            <Button className="text-area-controls" onClick={onClearClick}>
                              Clear
                            </Button>

                            <Tooltip
                              getPopupContainer={rootContainer}
                              placement="topLeft"
                              title={
                                'A modal window will open where it will be possible to select an object that will be substituted for the data of this object when filling out the form.'
                              }
                            >
                              <Button className="text-area-controls" onClick={onAddObjectMapToTextareaClick}>
                                Add object map to textarea
                              </Button>
                            </Tooltip>
                          </Space>

                          <Form.Item
                            name={mappingConstants.CUSTOM_TEXT_FIELD_NAME}
                            rules={[{ required: true, message: 'Please input the custom text.' }]}
                          >
                            <TextArea rows={4} readOnly={calculateSumCheckboxValue} />
                          </Form.Item>
                        </>
                      ) : undefined}
                    </Form.Item>
                  </Panel>
                </Collapse>
              </Form>

              <Collapse size="small">
                <Panel header="Mapped Objects" key="1" size="small">
                  <MappingTree
                    originalMappingObjects={mappingObjectNames}
                    userMappingObjects={userMappingObjects}
                    setTargetFocus={setTargetFocus}
                    setShowMappingModal={setShowMappingModal}
                  />
                </Panel>
              </Collapse>
            </>
          )}
        </Modal>
      )}
    </>
  );
};

export default mappingModal;
